export const getMenuData = [
  {
    category: true,
    title: 'Menú Principal',
  },
  {
    title: 'Banner Principal',
    key: 'sliders',
    icon: 'fe fe-image',
    url: '/sliders',
  },
  {
    title: 'Banner Estático',
    key: 'static-banner',
    icon: 'fe fe-camera',
    url: '/static-banner',
  },
  {
    title: 'Publicidad',
    key: 'advertising',
    icon: 'fa fa-bullhorn',
    url: '/advertising',
  },
  // {
  //   title: 'Privacidad',
  //   key: 'privacy',
  //   icon: 'fe fe-lock',
  //   url: '/privacy',
  // },
  {
    title: 'Imagenes menú',
    key: 'images-menu',
    icon: 'fe fe-list',
    url: '/images-menu',
  },
  // {
  //   title: 'Multimedia',
  //   key: 'multimedia',
  //   icon: 'fe fe-film',
  //   url: '/multimedia',
  // },
  {
    title: 'Perfiles',
    key: 'profiles',
    icon: 'fe fe-user',
    url: '/profiles',
  },
  {
    title: 'Nuevos Servicios',
    key: 'new-services',
    icon: 'fe fe-list',
    url: '/new-services',
  },
  {
    title: 'Braze',
    key: 'braze',
    icon: 'fa fa-address-book',
    url: '/braze',
  },
  {
    title: 'Términos y condiciones',
    key: 'terms',
    icon: 'fa fa-address-book',
    url: '/terms',
  },
  // {
  //   category: true,
  //   title: 'Dashboards',
  // },
  // {
  //   title: 'Dashboards',
  //   key: 'dashboards',
  //   icon: 'fe fe-home',
  //   count: 6,
  //   children: [
  //     {
  //       title: 'Empty Page',
  //       key: 'dashboard',
  //       url: '/',
  //     },
  //   ],
  // },
  // {
  //   category: true,
  //   title: 'Components',
  // },
  // {
  //   title: 'Bootstrap',
  //   key: 'bootstrap',
  //   icon: 'fe fe-bookmark',
  //   url: '/ui-kits/bootstrap',
  // },
  // {
  //   title: 'Ant Design',
  //   key: 'antDesign',
  //   icon: 'fe fe-bookmark',
  //   url: '/ui-kits/antd',
  // },
]
